/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, day: NonNullable<unknown> }} Body_Measures_Series_RangeInputs */

const en_us2_body_measures_series_range = /** @type {(inputs: Body_Measures_Series_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} readings · ${i?.day}`)
};

const pt_br2_body_measures_series_range = /** @type {(inputs: Body_Measures_Series_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} registros · ${i?.day}`)
};

const es_419_body_measures_series_range = /** @type {(inputs: Body_Measures_Series_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} registros · ${i?.day}`)
};

const pt_pt2_body_measures_series_range = /** @type {(inputs: Body_Measures_Series_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} registos · ${i?.day}`)
};

const fr_fr2_body_measures_series_range = /** @type {(inputs: Body_Measures_Series_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mesures · ${i?.day}`)
};

const de_de2_body_measures_series_range = /** @type {(inputs: Body_Measures_Series_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Messungen · ${i?.day}`)
};

const it_it2_body_measures_series_range = /** @type {(inputs: Body_Measures_Series_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} misure · ${i?.day}`)
};

/**
* | output |
* | --- |
* | "{count} readings · {day}" |
*
* @param {Body_Measures_Series_RangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_series_range = /** @type {((inputs: Body_Measures_Series_RangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Series_RangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_series_range(inputs)
	if (locale === "es-419") return es_419_body_measures_series_range(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_series_range(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_series_range(inputs)
	if (locale === "de-DE") return de_de2_body_measures_series_range(inputs)
	if (locale === "it-IT") return it_it2_body_measures_series_range(inputs)
	return en_us2_body_measures_series_range(inputs)
});
export { body_measures_series_range as "body-measures.series_range" }